<div class="filters-menu-btns">
  <button id="saveFilterProfileAsBtn" (click)="onSaveFilterProfileAs()" class="filter-menu-btn"
    title="{{'main.filters.profiles.buttons.save_as' | translate}}"><i class="fa fa-save save-icon"></i
  >{{'main.filters.profiles.buttons.save_as' | translate}}</button>
  @if (showSaveBtn) {
    <button id="saveFilterProfileBtn" (click)="onSaveFilterProfile()" class="filter-menu-btn"
      title="{{'main.filters.profiles.buttons.save' | translate}}"><i class="fa fa-save save-icon"></i
    >{{'main.filters.profiles.buttons.save' | translate}}</button>
  }
</div>